module.exports = __webpack_public_path__ + "static/media/Contacts_white.01601354.svg";